export const roundTo2Decimals = (num: number) => {
  return new Intl.NumberFormat('en', { maximumFractionDigits: 2 }).format(num);
};
